import { css } from "styled-components";
import { BackdropForeground } from "../../components/Foreground";
import { BackdropBackground } from "../../components/Background";
export const riotProductSkin = () => css `
  ${BackdropForeground},
  ${BackdropBackground} {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: 50%;
    }
  }
  ${BackdropForeground} {
    display: block;

    /* TODO: remove these opinonated styles from default BackdropForeground */
    top: clamp(0px, 20vw, 160px);
    bottom: 0;
    left: 0;
    right: 0;

    > img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: 50% 100%;
    }
  }
`;
//# sourceMappingURL=index.js.map